import "../components/loader/index";
// seq code
const discussions_tagged_recipe = async () => {
  console.info("Tagged Discussions recipe");
};

discussions_tagged_recipe();
